module.exports = __webpack_public_path__ + "static/media/school-summer-vacation.66ac2276.svg";